import { Component, effect, inject } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Params,
  Router,
  RouterOutlet,
} from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AppTranslateService } from "@services/app-translate.service";
import { LoadingService } from "@services/loading.service";
import { RegistrationService } from "@services/registration.state";
import { ToastModule } from "primeng/toast";
import { filter, map, tap } from "rxjs";
import { BusinessType } from "./types/api/registration.types";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, ToastModule, TranslateModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  loading = inject(LoadingService).overlayLoader;
  title = "on-boarding";
  #registrationState = inject(RegistrationService);
  router = inject(Router);
  appTranslateService = inject(AppTranslateService);
  steps = this.#registrationState.steps;
  currentStep = this.#registrationState.currentStep;
  state = this.#registrationState.registrationSession;
  currentLocation = this.#registrationState.currentLocation;
  currentUser = this.#registrationState.currentUser;
  businessType = this.#registrationState.businessType;
  initialQueryParams: any = {};

  constructor(private route: ActivatedRoute) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.router.url)
      )
      .subscribe(() => {
        const currentUrl = this.router.url;
        if (currentUrl !== "/sign-up/business-type" && !this.businessType()) {
          this.router.navigate(["/sign-up/business-type"]);
        }

        if (
          (currentUrl.includes("registration") ||
            currentUrl.includes("complete")) &&
          !this.state()
        ) {
          this.router.navigate(["/sign-up/business-type"]);
        }
      });

    effect(() => {
      console.log("steps", this.steps());
      console.log("current step", this.currentStep());
      console.log("state", this.state());
      console.log("currentLocation", this.currentLocation());
      console.log("Current User", this.currentUser());
    });
  }
  ngOnInit() {
    const fullUrl = window.location.href;
    localStorage.setItem("fullUrl", fullUrl);
    
    let lang = this.appTranslateService.config.language;

    this.route.queryParams.subscribe((params) => {
      const language = params["language"];
      const businessType = params["businessType"];
      if (businessType) {
        const normalizedBusinessType = Object.values(BusinessType).find(
          (type) => type.toLowerCase() === businessType.toLowerCase()
        );
        this.#registrationState.updateBusinessTypeSelection(
          normalizedBusinessType
        );
        if (normalizedBusinessType === BusinessType.Corporation) {
          this.router.navigate(["/sign-up/register-corporation"]);
        } else {
          this.router.navigate(["/sign-up/mobile-verification"]);
        }
      }

      if (language && language !== lang) {
        this.appTranslateService.setLayoutDirection();
      }

      this.saveParamsToLocalStorage(params);
    });
  }

  saveParamsToLocalStorage(params: Params) {
    const keys = Object.keys(params).filter((key) => key !== "source"); // Exclude "source"

    if (keys.length) {
      localStorage.setItem("queryParamsKeys", JSON.stringify(keys));

      for (const key of keys) {
        localStorage.setItem(key, params[key]);
      }
    }

    // Store "source" separately in localStorage because marketing want this to live forever
    if (params["source"]) {
      localStorage.setItem("source", params["source"]);
    }
  }
  
}
